// eslint-disable-next-line no-use-before-define
import React, { useState, useEffect } from 'react';
import { useHistory, NavLink, useLocation } from 'react-router-dom';
import {
  Paper, Box, Typography,
  Grid, MenuItem, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Link,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HistoryIcon from '@mui/icons-material/History';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import NoteOutlinedIcon from '@mui/icons-material/NoteOutlined';
import { getHistorico, putNotificacoes } from '../../services/solicitacaoAPI';
import { colors } from '../../services/colors';
import BackTitle from '../../components/BackTitle';
import LoadingFull from '../../components/LoadingFull';
import { Solicitacao } from '../models';
import Modal from '../../components/Modal';
import MinhaSolicitacao from '../MinhaSolicitacao';

export default function Historico() {
  const history = useHistory();
  const location = useLocation<any>();
  const [loading, setLoading] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [historicoLista, setHistoricoLista] = useState<any>([]);
  useEffect(() => {
    async function get() {
      setLoading(true);
      if (location?.state?.notifica && location?.state?.notifica.length > 0) {
        const notifica = await putNotificacoes(location?.state?.notifica);
      }
      const getHist = await getHistorico();
      if (getHist.dados) {
        setHistoricoLista(getHist.dados);
      }
      setLoading(false);
    } get();
  }, []);

  return (
    <>
      <BackTitle
        title="Histórico de solicitações"
        icon={(
          <HistoryIcon sx={{
            color: colors.themePrimary,
            fontSize: '30px',
            marginLeft: '10px',
          }}
          />
)}
      />
      <LoadingFull open={loading} />
      <Grid item xs={12}>
        {historicoLista.length !== 0 ? (
          <>
            <Typography>Minhas solicitações</Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#ebebeb', borderRadius: '5px !important' }}>
                    <TableCell>Categoria</TableCell>
                    <TableCell>Detalhes</TableCell>
                    <TableCell>Data de abertura</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Ver</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                      historicoLista.map((e: Solicitacao, index: number) => (
                        <TableRow key={e.solicitacaoId}>
                          <TableCell>
                            {e.nomeCategoria}
                          </TableCell>
                          <TableCell>
                            {e.descricao}
                          </TableCell>
                          <TableCell>
                            {new Date(e.dataCriacao).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            {e.statusFormatado}
                          </TableCell>
                          <TableCell>
                            <NavLink to={`/MinhaSolicitacao/${e.solicitacaoId}`}>
                              <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                              >
                                <DescriptionOutlinedIcon color="primary" />
                              </IconButton>
                            </NavLink>
                          </TableCell>
                        </TableRow>
                      ))
                      }
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : (
          !loading
          && <Typography align="center" variant="h5" sx={{ marginTop: '10px' }}>Não existem solicitações cadastradas até o momento para o usuário</Typography>
        )}
      </Grid>
    </>
  );
}
